import { render, staticRenderFns } from "./chatHomeTeaser.vue?vue&type=template&id=216cd14e&scoped=true"
import script from "./chatHomeTeaser.vue?vue&type=script&lang=js"
export * from "./chatHomeTeaser.vue?vue&type=script&lang=js"
import style0 from "./chatHomeTeaser.vue?vue&type=style&index=0&id=216cd14e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216cd14e",
  null
  
)

export default component.exports